import { render, staticRenderFns } from "./FamilyReplyMessageConfirm.vue?vue&type=template&id=2b6af4c4&lang=pug"
import script from "./FamilyReplyMessageConfirm.vue?vue&type=script&lang=ts"
export * from "./FamilyReplyMessageConfirm.vue?vue&type=script&lang=ts"
import style0 from "./FamilyReplyMessageConfirm.vue?vue&type=style&index=0&id=2b6af4c4&prod&lang=scss&scopeed=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports